import useDragRest from '@spa/scenes/Plannings/DnD/DragRest/useDragRest'
import type { PropsWithChildren, FC } from 'react'
import React from 'react'

type Props = {
  restId: number
  weeklyscheduleId: number
}

const DragRest: FC<PropsWithChildren<Props>> = ({
  children,
  restId,
  weeklyscheduleId
}) => {
  const { handleRef, previewRef } = useDragRest({
    restId,
    weeklyscheduleId
  })

  const divHandleRef = React.useRef<HTMLDivElement>(null)
  const handleCombinedRef = React.useCallback(
    (node: HTMLDivElement) => {
      divHandleRef.current = node
      if (handleRef) {
        handleRef(node)
      }
    },
    [handleRef]
  )

  const divPreviewRef = React.useRef<HTMLDivElement>(null)
  const previewCombinedRef = React.useCallback(
    (node: HTMLDivElement) => {
      divPreviewRef.current = node
      if (previewRef) {
        previewRef(node)
      }
    },
    [previewRef]
  )

  return (
    <div ref={handleCombinedRef}>
      <div ref={previewCombinedRef}>{children}</div>
    </div>
  )
}

export default DragRest
